
import { Component, Ref, Vue } from 'vue-property-decorator'
import SidemenuLayoutBase from '@/components/organisms/layout/SidemenuLayoutBase.vue'
import SidemenuInformationPanel from '@/components/organisms/manage/SidemenuInformationPanel.vue'
import ModalEditUserData from '@/views/modal/ModalEditUserData.vue'
import ModalEditUserPassword from '@/views/modal/ModalEditUserPassword.vue'
import { TeacherSideMenuTopic } from '@/const/manage/TeacherSideMenuTopic'
import { AvatarCode } from '@/const/AvatarCode'
import { InformationPanelColorSet } from '@/const/manage/InformationPanelColorSet'
import { UserRole } from '@/const/UserRole'

/**
 * 先生用左側メニュー
 *
 * template部品のルート要素で使用し、メイン部分に表示する内容をslotで渡す
 *
 * ex)
 * teacher-sidemenu-layout.any-template
 *   .any-template__item 右側メイン部分に表示する内容
 */
@Component({
  components: {
    SidemenuLayoutBase,
    SidemenuInformationPanel,
    ModalEditUserData,
    ModalEditUserPassword,
  },
})
export default class TeacherSidemenuLayout extends Vue {
  /** サイドメニュー基底部 */
  @Ref()
  sidemenuLayout!: SidemenuLayoutBase

  /** ユーザ情報編集モーダル */
  @Ref()
  modalEditUserData!: ModalEditUserData

  /** パスワード編集モーダル */
  @Ref()
  modalEditUserPassword!: ModalEditUserPassword

  /** 権限 */
  private readonly role = UserRole.TEACHER

  /** 現在のビューモード(light or dark) */
  private isDarkMode = false

  /** クッキーから取得した先生情報 */
  private teacher = this.$appCookies.authTeacher.get()

  /** インフォメーションパネルのカラーセット */
  private informationPanelColorSet: InformationPanelColorSet.ColorSet = InformationPanelColorSet.TEACHER

  /**
   * 先生のアイコン画像パス
   *
   * @returns 画像のパス
   */
  private get teacherId(): string {
    return this.teacher.loginId
  }

  /**
   * 先生のニックネーム
   *
   * @returns ニックネーム
   */
  private get teacherNickName(): string {
    return this.teacher.nickname
  }

  /**
   * 先生のアイコン画像パス
   *
   * @returns 画像のパス
   */
  private get imageUrl(): string {
    const code = this.teacher.avatarIconCode
    return AvatarCode.findByCode(code).path
  }

  /**
   * メニュー項目一覧
   *
   * @returns 項目リスト
   */
  private get topicList(): TeacherSideMenuTopic.Topic[] {
    return TeacherSideMenuTopic.LIST
  }

  /**
   * ビューモードを切り替える
   * TODO ダークモード実装後に修正
   */
  private toggleViewMode(): void {
    alert('ダークモード切り替え')
    this.isDarkMode = !this.isDarkMode
  }

  /**
   * 編集ボタン押下時の処理
   */
  private async onEditButton(): Promise<void> {
    await this.modalEditUserData.show(this.teacher.userId)
  }

  /**
   * ログアウトボタン押下時の処理
   */
  private onLogoutButton(): void {
    if (!confirm('ログアウトしますか？')) {
      return
    }
    // クッキー情報を削除
    this.$appCookies.removeAuth()
    // ログイン画面に遷移
    this.$router.push('/teacher/login')
  }

  /**
   * パスワード変更ボタン押下時の処理
   */
  private onChangePasswordButton(): void {
    this.modalEditUserPassword.show()
  }
}
